import ApiService from '@shared/services/api.service';

const endPoint = '/blackout_periods';
const urlsEndPoint = '/urls/simple';
const urlsFullEndPoint = '/urls';

const BlackoutPeriodService = {
  getList() {
    return ApiService.get(endPoint);
  },

  async getUrlList(options = {}) {
    const {
      page = null,
      itemsPerPage = 1000,
      q = '',
      userId = null,
      statusCode = null,
      preferSimpleWhenPossible = true
    } = options;

    // Build query string
    const params = new URLSearchParams();

    if (page) {
      params.append('page', page);
    }
    params.append('items_per_page', itemsPerPage);

    if (q) {
      params.append('q', q);
    }

    if (userId) {
      params.append('user_id', userId);
    }

    if (statusCode) {
      params.append('status_code', statusCode);
    }

    const useFullEndpoint = Boolean(statusCode) || !preferSimpleWhenPossible;
    const url = `${useFullEndpoint ? urlsFullEndPoint : urlsEndPoint}?${params.toString()}`;
    const response = await ApiService.get(url);
    
    // Handle non-paginated response (backwards compatibility)
    if (Array.isArray(response)) {
      return response;
    }
    
    // If page was specified, return paginated response as-is
    if (page) {
      return response;
    }
    
    // No page specified: fetch all pages by getting 1 first, then fetch remaining pages in batches
    if (response && response.data && response.meta) {
      let allData = [...response.data];
      const { current_page, last_page } = response.meta;
      
      // Fetch remaining pages if there are more
      if (current_page < last_page) {
        const pagePromises = [];
        for (let p = current_page + 1; p <= last_page; p++) {
          pagePromises.push(ApiService.get(`${url}&page=${p}`));
        }
        
        const pageResponses = await Promise.all(pagePromises);
        for (const pageResponse of pageResponses) {
          if (pageResponse && Array.isArray(pageResponse.data)) {
            allData = allData.concat(pageResponse.data);
          }
        }
      }
      
      return allData;
    }
    
    // Fallback: return response as-is if structure is unexpected
    return response || [];
  },

  create(bodyParams) {
    return ApiService.post(`${endPoint}`, bodyParams);
  },

  createRecurring(bodyParams) {
    return ApiService.post(`${endPoint}/recurring`, bodyParams);
  },

  update(start, end, bodyParams) {
    return ApiService.put(`${endPoint}/${start}/${end}`, bodyParams);
  },

  get(start, end) {
    return ApiService.get(`${endPoint}/${start}/${end}`);
  },

  delete(start, end) {
    return ApiService.delete(`${endPoint}/${start}/${end}`);
  },

  batchDelete(body) {
    return ApiService.delete(`${endPoint}/batch_delete`, { data: body });
  }
};
export default BlackoutPeriodService;
